import { configAxiosCampaign } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const getEngelinkAds = async (queriesStrings = '') => {
    const api = configAxiosCampaign();
    const { data } = await api.get(`${ENDPOINTS.CAMPAIGN}${queriesStrings}`);
    return { data };
};

export const sendEngelinkAdsClicks = async (payload) => {
    const api = configAxiosCampaign();
    const { data } = await api.post(`${ENDPOINTS.CLICK_CAMPAIGN}`, payload);
    return { data };
};

export const getPopUp = async () => {
    const api = configAxiosCampaign();
    const { data } = await api.get(`${ENDPOINTS.CAMPAIGN_INTERNAL}`);
    return data;
};

export const sendPopUpClicks = async (id) => {
    const api = configAxiosCampaign();
    const { data } = await api.post(`${ENDPOINTS.CAMPAIGN_INTERNAL}${id}/click_in_campaign/`);
    return { data };
};

export const doNotShowPopUp = async (id) => {
    const api = configAxiosCampaign();
    const { data } = await api.post(`${ENDPOINTS.CAMPAIGN_INTERNAL}${id}/not_show_more/`);
    return { data };
};